import { APPLICANT_KIND } from '@flatsy/types/Applications/Applicant'
import { WizardContext, WizardEvent } from '../wizardMachine'
import { getLatestData } from './GetLatestData'

export const getTotalStep = (context: WizardContext, event: WizardEvent): number => {
  const latestContext = getLatestData(context, event)
  let counter = 1

  if (latestContext.asset?.is_sale) {
    /* -------------------------- ADD SALES BASE STATE -------------------------- */
    counter += 3
  } else {
    /* --------------------------- ADD RENT BASE STATE -------------------------- */
    counter += 2
    /* --------------------------- ADD APPLICANT STEP --------------------------- */
    if (latestContext.applicants && latestContext.applicants[0]) {
      latestContext.applicants.forEach((applicant) => {
        if (applicant.kind === APPLICANT_KIND.guarantor) {
          counter += 1
        } else {
          counter += 2
        }
        /* ------------------------------ ADD GUARANTOR ----------------------------- */
        if (latestContext.qualification) {
          const withGuarantor = [
            ...(latestContext.qualification.situation_guarantor_needed ?? []),
            ...(latestContext.qualification.situation_guarantor_asked ?? []),
          ].some((situation) => situation === applicant.situation)

          if (withGuarantor) {
            counter += 1
          }
        }
      })
    } else {
      counter += 1
    }
  }

  return counter
}
